import type { ReactNode } from 'react'
import type { StatusPillStyle } from '../utils'

// Copied presentational piece (pages/Billing pill styling) — decision: no
// legacy↔v2 component imports across page modules.
/**
 * Names which status a pill carries ("Claim", "Payment") — muted text and a hairline ahead
 * of the status word, so two pills reading the same value stay tellable apart. Shared with
 * ClaimStatusControl's popover trigger, which is a Button styled as a pill.
 */
export function PillLabel({ label, borderColor }: { label: string; borderColor: string }) {
  return (
    <>
      <span style={{ color: '#475569', fontWeight: 500 }}>{label}</span>
      <span
        aria-hidden
        style={{ width: 1, height: 14, marginInline: 8, backgroundColor: borderColor }}
      />
    </>
  )
}

export function StatusPill({
  style,
  label,
  children,
}: {
  style: StatusPillStyle
  label?: string
  children: ReactNode
}) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        height: 28,
        paddingInline: 12,
        borderRadius: 8,
        border: `1px solid ${style.borderColor}`,
        backgroundColor: style.backgroundColor,
        color: style.color,
        fontSize: 13,
        fontWeight: 600,
        whiteSpace: 'nowrap',
      }}
    >
      {label ? <PillLabel label={label} borderColor={style.borderColor} /> : null}
      {children}
    </span>
  )
}
